<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <!-- post START here -->
        <h5>Forgot Password?</h5>
        <div v-if="errors.any()" id="feedback">
          <p v-if="errors.has('email')" class="error wrong_message error-box">
            Please enter an email
          </p>
        </div>
        <form v-if="!success" name="formforgotpw">
          <p>Enter Email Address: <input v-model="email" v-validate="'required|email'" type="text" name="email" data-vv-delay="1000"></p>
          <p><input type="submit" name="submit" value="Reset Password" @click.prevent="reset"></p>
        </form>
        <div v-if="success" id="success" class="success-box">
          Password reset has been sent! <span class="close">x</span>
        </div>
        <p>Check your email for the new password. Please be sure to check your spam folder. </p>
        <p>Please contact support@stumpthespread if you have forgotten your login id.</p>
      <!-- post END here -->
      </div>
      <!-- main-colum END here -->
      <!-- sidebar START here -->
      <sidebar :testimonial="testimonial"></sidebar>
    <!-- sidebar END here -->
    </div>
  <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import Sidebar from '../components/sidebar.vue'
import TestimonialRepository from '../data/testimonial.repository.js'
import AuthRepository from '../data/auth.repository.js'
export default {
  components: {
    'sidebar': Sidebar
  },
  data () {
    return {
      email: '',
      success: false,
      testimonial: {}
    }
  },
  created () {
    TestimonialRepository.getTestimonials(1).then(test => {
      this.testimonial = test
    })
  },
  methods: {
    reset () {
      this.$validator.validateAll().then(() => {
        AuthRepository.resetPassword(this.email).then((result) => {
          this.success = true
          this.$root.$refs.toastr.s('Password Request has been Sent')
        }).catch(() => this.$root.$refs.toastr.e('An error occurred'))
      })
    }
  },
  metaInfo: {
    title: 'Forgot Password'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?6b8b2921